import React, { FunctionComponent } from 'react'
import { Box } from '@material-ui/core'
import Toolbar from './partials/Toolbar'
import List from './partials/List'
import { SpecialRatesProvider } from './SpecialRatesProvider'
import Message, { MessageProvider } from 'components/elements/Message'

export type Props = {}
export type Functions = {}

export type AllProps = Props & Functions

const SpecialRates: FunctionComponent<AllProps> = ({}) => {
  return (
    <Box p={1.5}>
      <SpecialRatesProvider>
        <MessageProvider>
          <Toolbar />
          <List />
          <Message />
        </MessageProvider>
      </SpecialRatesProvider>
    </Box>
  )
}

export default SpecialRates
